import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { LocalStorageService } from 'ngx-webstorage';
import { Globle } from 'src/assets/globle';
import { Messages } from '../messages.model';
import { OptionService } from '../option.service';
import { Clipboard } from '@angular/cdk/clipboard';

@Component({
  selector: 'app-messages',
  templateUrl: './messages.component.html',
  styleUrls: ['./messages.component.css'],
  queries: {
    contentRef: new ViewChild("Modal"),
    contentRef1: new ViewChild("ModalView"),
    contentRef2: new ViewChild("ModalViewImg"),
    contentRef3: new ViewChild("ModalConfirmReject"),
    contentRef4: new ViewChild("ModalDeleteAll"),
  },
})
export class MessagesComponent implements OnInit {

  messages: Messages[] = [];
  displayedColumns: string[] = ['date', 'fullName', 'mobileNo', 'messageText',
    'imageUrl', 'view', "delete"];
  dataSource!: MatTableDataSource<Messages>;
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;
  spinnerOverlay = false
  public contentRef!: TemplateRef<any>;
  public contentRef1!: TemplateRef<any>;
  public contentRef2!: TemplateRef<any>;
  public contentRef3!: TemplateRef<any>;
  public contentRef4!: TemplateRef<any>;
  message: Messages = {} as Messages;
  messageType: { id: number, name: string }[] = [{ id: 0, name: "all" }, { id: 1, name: "directCharged" }, { id: 2, name: "others" }];
  chargedStatus: { id: number, name: string }[] = [{ id: -1, name: "all" }, { id: 1, name: "chargedDone" },
  { id: 0, name: "notCharged" }, { id: 2, name: "rejected" }];
  selectedStatus: number = -1;
  selectedMessageType: number = 2;
  message_text!: string;
  imgView!: string;
  rejectReason: string = "";
  id: any;
  pageSize = 100;
  userLoginId!: string;
  constructor(private service: OptionService,
    private snackBar: MatSnackBar,
    private globle: Globle,
    private localStorage: LocalStorageService,
    private clipboard: Clipboard,
    private dialog: MatDialog) { }

  ngOnInit() {

    this.pageSize = this.globle.pageSize;
    this.getMessages();
    this.userLoginId = this.localStorage.retrieve("userInfo").userId;
    // setInterval(() => { this.getMessages(); }, 180000);

  }

  getMessages() {
    this.spinnerOverlay = true;
    this.service.getMessages().subscribe(data => {

      this.messages = data.sort((n1, n2) => n2.id - n1.id);
      this.dataSource = new MatTableDataSource(this.messages);
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
      this.spinnerOverlay = false;
    },
      error => {
        this.spinnerOverlay = false;
        console.log(error);
      })
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  edit(item: any) {
    this.message_text = item.message;
    this.openDialogView();
  }

  onDelete(id: number) {
    this.message.id = id;
    this.openDialog();
  }

  delete() {
    this.spinnerOverlay = true;
    this.dialog.closeAll();
    this.service.deleteMessages(this.message.id).subscribe(data => {
      this.openSnackBar("Deleted successfully", 'snackBarSuccess');
      this.spinnerOverlay = false;
      this.getMessages();
    },
      error => {
        console.log(error);
        this.spinnerOverlay = false;
        this.dialog.closeAll();
        if (error.error.message) {
          this.openSnackBar(error.error.message, "snackBarError");
        }
        else {
          this.openSnackBar("Internal server error", "snackBarError");
        }
      })
  }

  confirmDelete() {
    this.delete();
  }

  openSnackBar(message: string, cssclass: string) {
    this.snackBar.open(message, 'Close', {
      duration: 6000,
      horizontalPosition: 'end',
      verticalPosition: 'top',
      panelClass: cssclass
    });
  }

  openDialog(): void {
    const dialogRef = this.dialog.open(this.contentRef, {
      width: '300px',
    });
  }

  openDialogView(): void {
    const dialogRef = this.dialog.open(this.contentRef1, {
      width: '500px',
    });
  }

  onNoClick(): void {
    this.dialog.closeAll();
  }

  viewImg(img: any) {
    this.imgView = img;
    this.openDialogImg();

  }

  openDialogImg(): void {
    const dialogRef = this.dialog.open(this.contentRef2, {
      width: '1000px',
      height: '1000px'
    });
  }

  openDialogReject(): void {
    const dialogRef = this.dialog.open(this.contentRef3, {
      width: '250px',
      height: '250px'
    });
  }

  onChargedDone(data: any) {
    this.spinnerOverlay = true;
    this.message = data;
    this.service.updateStatusMessage(this.message.id, 1, "").subscribe(data => {
      this.createPermNotification("تم شحن بطاقة  " + this.message.product,
        "تم شحن بطاقة  " + this.message.product, this.message.playerId);
      this.openSnackBar("تم التعديل بنجاح", 'snackBarSuccess');

      this.getMessages();
    },
      error => {
        console.log(error);
        this.spinnerOverlay = false;
        if (error.error.message) {
          this.openSnackBar(error.error.message, "snackBarError");
        }
        else {
          this.openSnackBar("حدث خطأ بالنظام", "snackBarError");
        }
      })

  }

  onMessageTypeChange() {
    if (this.selectedMessageType == 2) {
      this.displayedColumns = ['date', 'fullName', 'mobileNo', 'messageText', 'imageUrl', 'view', "delete"];
    }
    else {
      this.displayedColumns = ['date', 'fullName', 'mobileNo', 'messageText', 'imageUrl', 'view', 'updateStatus', 'reject', "delete"];
    }
    this.getMessages();
  }

  onReject(data: any) {
    this.id = data.id;
    this.message = data;
    this.openDialogReject();
  }

  confirmReject() {
    this.spinnerOverlay = true;
    this.service.updateStatusMessage(this.id, 2, this.rejectReason).subscribe(data => {
      this.openSnackBar("تم التعديل بنجاح", 'snackBarSuccess');
      this.createPermNotification("تم رفض شحن بطاقة  " + this.message.product +
        "(" + this.message.message + ")" + "- (سبب الرفض : " + this.rejectReason + ")",
        "تم رفض شحن بطاقة  " + this.message.product, this.message.playerId);
      this.spinnerOverlay = false;
      this.getMessages();
      this.dialog.closeAll();
    },
      error => {
        console.log(error);
        this.spinnerOverlay = false;
        this.dialog.closeAll();
        if (error.error.message) {
          this.openSnackBar(error.error.message, "snackBarError");
        }
        else {
          this.openSnackBar("حدث خطأ بالنظام", "snackBarError");
        }
      })
  }

  createPermNotification(permNotfbody: string, pushNotifBody: string, playerId: string) {
    var obj =
    {
      "title": "شحن مباشر",
      "message": permNotfbody,
      "usersIds": [this.message.userId],
      "createBy": this.userLoginId,
      "playerId": playerId
    }

    this.service.createPermNotifications(obj).subscribe(data => {
      this.sendNotification(this.message.fcmToken, pushNotifBody);
    }, error => {
      console.log(error);
    })
  }

  sendNotification(fcmToken: string, body: string) {

    // var obj = {
    //   "to": fcmToken,
    //   "notification": {
    //     "title": "شحن مباشر",
    //     "body": body
    //   }
    // }

    // this.service.sendNotification(obj).subscribe(data => {

    // },
    //   error => {
    //     console.log(error)
    //     this.openSnackBar(error, 'snackBarError');
    //     this.spinnerOverlay = false;
    //   })
  }

  onCopy(data: any) {

  }


  openSnackBarCopy(playerId: string) {
    this.snackBar.open("تم نسخ  " + playerId, 'Close', {
      duration: 2000,
      horizontalPosition: 'center',
      verticalPosition: 'bottom',
      panelClass: "snackBarSuccess"
    });
  }

  copyPlayerId(playerId: string) {
    this.clipboard.copy(playerId);
    this.openSnackBarCopy(playerId);
  }

  statusChange() {
    if (this.selectedStatus == 1 || this.selectedStatus == 2) {
      this.displayedColumns = ['date', 'fullName', 'mobileNo', 'messageText', 'copy', 'imageUrl', 'view', "delete"];
    }
    else {
      this.displayedColumns = ['date', 'fullName', 'mobileNo', 'messageText', 'copy', 'imageUrl', 'view', 'updateStatus', 'reject', "delete"];
    }

    this.getMessages();
  }

  onDeleteAll() {
    if (this.messages.length > 0) {
      this.openDialogDeleteAll()
    }
    else {
      this.openSnackBar("لا يوجد بيانات", 'snackBarError');
    }
  }

  openDialogDeleteAll(): void {
    const dialogRef = this.dialog.open(this.contentRef4, {
      width: '400px',
    });
  }

  confirmDeleteBulk() {
    this.deleteAll()
  }

  deleteAll() {
    this.spinnerOverlay = true;
    this.dialog.closeAll();
    this.service.deleteAllMessages().subscribe(data => {
      this.openSnackBar("Deleted successfully", 'snackBarSuccess');
      this.spinnerOverlay = false;
      this.getMessages();
    },
      error => {
        console.log(error);
        this.spinnerOverlay = false;
        this.dialog.closeAll();
        if (error.error.message) {
          this.openSnackBar(error.error.message, "snackBarError");
        }
        else {
          this.openSnackBar("Internal server error", "snackBarError");
        }
      })
  }
}
